export default "__VITE_ASSET__e76cb8cd__"